import React from 'react'

const SparkleIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="sparkleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(255, 220, 120, 1)" />
          <stop offset="50%" stopColor="rgba(255, 200, 80, 1)" />
          <stop offset="100%" stopColor="rgba(255, 180, 100, 1)" />
        </linearGradient>
        <filter id="sparkleGlow">
          <feGaussianBlur stdDeviation="1.5" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Main sparkle star */}
      <path 
        d="M12 2 L13.5 8.5 L20 10 L13.5 11.5 L12 18 L10.5 11.5 L4 10 L10.5 8.5 Z"
        fill="url(#sparkleGradient)"
        filter="url(#sparkleGlow)"
      />
      
      {/* Small sparkle top right */}
      <path 
        d="M18 5 L18.5 6.5 L20 7 L18.5 7.5 L18 9 L17.5 7.5 L16 7 L17.5 6.5 Z"
        fill="rgba(255, 220, 150, 0.8)"
      />
      
      {/* Small sparkle bottom left */}
      <path 
        d="M6 15 L6.5 16.5 L8 17 L6.5 17.5 L6 19 L5.5 17.5 L4 17 L5.5 16.5 Z"
        fill="rgba(255, 220, 150, 0.8)"
      />
    </svg>
  )
}

export default SparkleIcon
